var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwenty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f2f60;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n\n      .cls-3 {\n        fill: #ebebeb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M637.58,535.49l-54-170.03c-5.88-18.51,3.71-38.39,21.85-45.32l62.88-24.02,34.97,24.15-12.08,45.56-27.3,10.43,43.52,137.06c6.13,19.29-4.55,39.89-23.83,46.02-19.22,6.1-39.87-4.47-46.02-23.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M809.72,281.34c-7.22-18.91-28.4-28.38-47.31-21.16l-94.1,35.94,22.89,69.71,97.36-37.19c18.91-7.22,28.38-28.4,21.16-47.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M631.14,1014c-25.47-6.7-40.69-32.78-34-58.25l46.93-178.48-46.93-178.48c-6.7-25.47,8.52-51.55,34-58.25,25.47-6.7,51.55,8.52,58.25,34l50.12,190.6c2.09,7.95,2.09,16.3,0,24.26l-50.12,190.6c-6.7,25.47-32.78,40.69-58.25,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M775.08,1013.5c-25.2-7.67-39.41-34.31-31.75-59.51l27.73-186.97-77.5-153.1c-15.05-21.61-9.74-51.34,11.88-66.39,21.61-15.05,51.34-9.74,66.39,11.88l90.73,172.1c8.35,11.99,10.75,27.15,6.49,41.14l-34.46,209.11c-7.63,25.08-34.19,39.45-59.51,31.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M565.47,648.35c-5.57,12.81,1.09,27.35,13.5,30.25,60.41,14.09,216.18,50.43,276.55,64.51,12.53,2.92,24.83-7.28,25.49-21.15l17.06-370.12c2.14-46.35-29.32-87.55-74.59-97.7-.58-.13-1.16-.26-1.74-.39-44.74-10.03-90.31,13.11-108.61,55.16l-147.67,339.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M932.01,138.27c-42.97-14.93-89.91,7.79-104.85,50.76s7.79,89.91,50.76,104.84c42.97,14.93,89.91-7.79,104.85-50.76,14.93-42.97-7.79-89.91-50.76-104.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M950.97,1010.45c-9.5,0-17.2-7.7-17.2-17.2v-396.59c0-32.87,26.74-59.62,59.62-59.62s59.62,26.74,59.62,59.62v54.42c0,9.5-7.7,17.2-17.2,17.2s-17.2-7.7-17.2-17.2v-54.42c0-13.9-11.31-25.21-25.21-25.21s-25.21,11.31-25.21,25.21v396.59c0,9.5-7.7,17.2-17.21,17.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M942.64,573.07l-112.43-76.33c-7.87-5.34-13.35-13.54-15.29-22.85l-13.34-64.08,31.04-33.34,40.62,17.96,10.41,50.01,100.16,68c16.74,11.37,21.1,34.16,9.73,50.9-11.38,16.77-34.18,21.09-50.9,9.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M873.23,394.43l-19.26-92.55c-4.12-19.81-23.53-32.53-43.34-28.41-19.81,4.12-32.53,23.53-28.41,43.34l19.35,93,71.66-15.38Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.04,521.38l-34.74-176.55c-3.78-19.22,8.09-38.05,27.06-42.93l81.12-20.86,38.35,29.16-22.1,42.98-45.17,11.61,28,142.31c3.94,20.03-9.1,39.46-29.13,43.4-19.94,3.92-39.44-9.01-43.4-29.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.5,286.29c-5.08-19.77-25.23-31.67-45-26.59l-83.03,21.35,16.26,72.14,85.17-21.9c19.77-5.08,31.67-25.23,26.59-45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.37,1015.58c-30.93,0-53.58-29.29-45.7-59.24l46.47-176.72-46.47-176.72c-6.63-25.22,8.44-51.05,33.66-57.68,25.23-6.63,51.05,8.44,57.68,33.66l49.62,188.73c2.07,7.87,2.07,16.14,0,24.02l-49.62,188.73c-5.57,21.2-24.71,35.22-45.64,35.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.94,1013.52c-24.95-7.59-39.03-33.97-31.44-58.92l40.7-185.13-89.98-151.6c-14.9-21.4-9.64-50.83,11.76-65.74,21.4-14.9,50.83-9.64,65.74,11.76l103.08,170.4c8.27,11.88,10.64,26.89,6.43,40.73l-47.37,207.05c-7.56,24.83-33.86,39.06-58.92,31.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.61,284.41l-74.19-25.71c-37.43-12.97-78.28,6.86-91.25,44.28l-95.1,274.47,139.22,53.58c38.02,13.18,79.52-6.97,92.7-44.99l72.91-210.38c12.97-37.43-6.86-78.28-44.29-91.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.52,1015.58c-9.58,0-17.35-7.77-17.35-17.35v-400c0-33.16,26.97-60.13,60.13-60.13s60.13,26.97,60.13,60.13v54.89c0,9.58-7.77,17.35-17.35,17.35s-17.35-7.77-17.35-17.35v-54.89c0-14.02-11.41-25.43-25.43-25.43s-25.43,11.41-25.43,25.43v400c0,9.58-7.77,17.35-17.35,17.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M426.79,592.34l-113.4-76.99c-7.94-5.39-13.47-13.65-15.42-23.05l-16.17-77.7,28.69-32.48,43.56,16.9,13.23,63.58,101.02,68.58c16.89,11.47,21.28,34.45,9.82,51.34-11.48,16.91-34.47,21.27-51.34,9.82h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M354.05,399.01l-16.69-80.2c-4.16-19.99-23.73-32.81-43.71-28.65-19.98,4.16-32.81,23.73-28.65,43.71l16.8,80.72,72.26-15.59Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 375.25,
    cy: 219.89,
    r: 81.52
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwenty);
export default __webpack_public_path__ + "static/media/twenty.dc58ba2b7b3824766f00056042eb47c3.svg";
export { ForwardRef as ReactComponent };